<app-side-menu>
  <div class="proposal-create-wrap purchase-orders-container">
    <div class="details-header d-flex justify-content-between align-items-start flex-wrap gap-2">
      <div>
        <h1 class="details-title">
          <i class="fas fa-file-circle-plus me-2"></i>
          Nova proposta de cotação
        </h1>
        <p class="details-subtitle mb-0">
          {{ purchaseOrder?.orderNumber || ('Pedido #' + purchaseOrderId) }}
        </p>
      </div>
      <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
        <i class="fas fa-arrow-left me-1"></i>
        Voltar
      </button>
    </div>

    <div *ngIf="isLoading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
    </div>

    <div class="alert alert-warning" *ngIf="!isLoading && !header">
      Não há processo de cotação ativo para este pedido. Inicie o processo antes de criar uma proposta.
    </div>

    <div class="card mt-3" *ngIf="!isLoading && purchaseOrder?.items?.length">
      <div class="card-header">
        <strong>Itens do pedido (visão situacional)</strong>
      </div>
      <div class="card-body p-0">
        <div class="d-flex justify-content-end p-3 pb-0">
          <span class="badge bg-primary">
            Total estimado do pedido: {{ estimatedItemsTotal() | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
          </span>
        </div>
        <div class="table-responsive">
          <table class="table table-sm align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th>Item</th>
                <th>Qtd</th>
                <th>Unidade</th>
                <th>Valor Estimado</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let it of purchaseOrder?.items">
                <td>{{ it.productName || it.itemName || '—' }}</td>
                <td>{{ it.quantityRequested }}</td>
                <td>{{ it.unit || '—' }}</td>
                <td>{{ it.estimatedTotalPrice | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</td>
                <td>{{ it.status || '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="card mt-3" *ngIf="!isLoading && header">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Fornecedor <span class="text-danger">*</span></label>
            <select
              class="form-select"
              [(ngModel)]="form.supplierId"
              [disabled]="hasNoSuppliersLeft">
              <option [ngValue]="null">
                {{ hasNoSuppliersLeft ? 'Nenhum fornecedor disponível' : 'Selecione...' }}
              </option>
              <option *ngFor="let s of availableSuppliers" [ngValue]="s.id">
                {{ s.companyName }}{{ s.tradeName ? ' — ' + s.tradeName : '' }}
              </option>
            </select>
            <div *ngIf="hasNoSuppliersLeft" class="form-text text-warning mt-1">
              <i class="fas fa-info-circle me-1"></i>
              Todos os fornecedores cadastrados já possuem proposta neste orçamento. Cadastre um novo fornecedor ou cancele uma proposta existente para liberar a opção.
            </div>
            <div
              *ngIf="!hasNoSuppliersLeft && existingProposals.length > 0"
              class="form-text text-muted mt-1">
              <i class="fas fa-filter me-1"></i>
              {{ existingProposals.length }} fornecedor(es) já cotados foram ocultados da lista.
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label">Código da proposta</label>
            <p class="form-control-plaintext border rounded px-3 py-2 mb-0 bg-light small text-muted">
              Será gerado automaticamente ao salvar (ex.: PROP-…).
            </p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Data da proposta</label>
            <input type="datetime-local" class="form-control" [(ngModel)]="form.quotationDate" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Válida até</label>
            <input type="datetime-local" class="form-control" [(ngModel)]="form.validUntil" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Moeda</label>
            <select class="form-select" [(ngModel)]="form.currencyCode">
              <option *ngFor="let c of currencyOptions" [ngValue]="c.code">
                {{ c.symbol }} — {{ c.label }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label">Valor total da compra</label>
            <input
              type="text"
              inputmode="numeric"
              class="form-control"
              appCurrencyShiftMask
              [(ngModel)]="form.itemsSubtotal"
              (ngModelChange)="recalculateTotal()" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Desconto</label>
            <input
              type="text"
              inputmode="numeric"
              class="form-control"
              appCurrencyShiftMask
              [(ngModel)]="form.discountAmount"
              (ngModelChange)="recalculateTotal()" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Frete</label>
            <input
              type="text"
              inputmode="numeric"
              class="form-control"
              appCurrencyShiftMask
              [(ngModel)]="form.freightAmount"
              (ngModelChange)="recalculateTotal()" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Outros custos</label>
            <input
              type="text"
              inputmode="numeric"
              class="form-control"
              appCurrencyShiftMask
              [(ngModel)]="form.otherCostsAmount"
              (ngModelChange)="recalculateTotal()" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Impostos</label>
            <input
              type="text"
              inputmode="numeric"
              class="form-control"
              appCurrencyShiftMask
              [(ngModel)]="form.taxAmount"
              (ngModelChange)="recalculateTotal()" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Total</label>
            <input
              type="text"
              inputmode="numeric"
              class="form-control"
              appCurrencyShiftMask
              [(ngModel)]="form.totalAmount" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Prazo pagamento (dias)</label>
            <input type="number" class="form-control" [(ngModel)]="form.paymentTermDays" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Prazo entrega (dias)</label>
            <input type="number" class="form-control" [(ngModel)]="form.deliveryLeadTimeDays" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Status</label>
            <input type="text" class="form-control" [(ngModel)]="form.status" maxlength="40" />
          </div>
          <div class="col-12">
            <label class="form-label">Observações</label>
            <textarea class="form-control" rows="3" [(ngModel)]="form.notes"></textarea>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary" (click)="goBack()" [disabled]="isSaving">Cancelar</button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="save()"
          [disabled]="isSaving || hasNoSuppliersLeft"
          [title]="hasNoSuppliersLeft ? 'Não há fornecedores disponíveis para nova proposta neste orçamento.' : ''">
          <i class="fas fa-spinner fa-spin me-1" *ngIf="isSaving"></i>
          Salvar proposta
        </button>
      </div>
    </div>
  </div>
</app-side-menu>
